import './components/inst-items.js'
import './components/sliders.js'
import './components/acc.js'
import './components/popup.js'
import './components/videos.js'
import './components/prod-tabs.js'
